import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButtonText from '@/components/_next/atoms/AzButtonText.vue';
import AzAccordion from '@/components/_next/molecules/AzAccordion.vue';
import AzRadio from '@/components/_next/molecules/AzRadio.vue';
import AzAccordionItem from '@/components/_next/molecules/AzAccordionItem.vue';
import { useSearchFacets } from '@/composables/_next/useSearchFacets';
import SearchFilterCheckboxOrganism from '@/components/_next/organisms/search/SearchFilterCheckboxOrganism.vue';
import SearchFilterNestedOrganism from '@/components/_next/organisms/search/SearchFilterNestedOrganism.vue';
import SearchFilterRangeOrganism from '@/components/_next/organisms/search/SearchFilterRangeOrganism.vue';
import SearchFilterTagOrganism from '@/components/_next/organisms/search/SearchFilterTagOrganism.vue';
import SearchFilterLinkOrganism from '@/components/_next/organisms/search/SearchFilterLinkOrganism.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFiltersOrganism',
  props: {
    availableFacets: null,
    sorting: null
  },
  emits: ['sort'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var route = useRoute();
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      updateSearchFacets = _useSearchFacets.updateSearchFacets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    var hasActiveFilters = computed(function () {
      var _Object$entries$find;
      return (_Object$entries$find = Object.entries(facets.value).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          id = _ref3[0];
        return !['type', 'letter', 'page'].includes(id);
      })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find.length;
    });
    function getSelectedCount(facet) {
      var param = route.query[facet.id];
      if (facet.type === 'nested') {
        var _Object$entries;
        return (_Object$entries = Object.entries(route.query)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.reduce(function (acc, _ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            id = _ref5[0],
            values = _ref5[1];
          if (facet.subfacets.find(function (subfacet) {
            return subfacet.id === id;
          })) {
            return Array.isArray(values) ? acc + values.length : acc + 1;
          }
          return acc;
        }, 0);
      } else if (!param) {
        return 0;
      } else if (!facet.type || facet.type === 'checkbox' || facet.type === 'tags') {
        return Array.isArray(param) ? param.length : 1;
      }
    }
    var sortOptions = computed(function () {
      var _props$sorting$option, _props$sorting, _props$sorting$option2;
      return (_props$sorting$option = (_props$sorting = props.sorting) === null || _props$sorting === void 0 ? void 0 : (_props$sorting$option2 = _props$sorting.options) === null || _props$sorting$option2 === void 0 ? void 0 : _props$sorting$option2.filter(function (option) {
        return option.id.includes('-lang') ? option.id.includes("-lang_".concat(locale)) : true;
      })) !== null && _props$sorting$option !== void 0 ? _props$sorting$option : [];
    });
    function onSortChange(_x) {
      return _onSortChange.apply(this, arguments);
    }
    function _onSortChange() {
      _onSortChange = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(sort) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateSearchFacets({
                sort: sort
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onSortChange.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      locale: locale,
      route: route,
      isMobile: isMobile,
      translate: translate,
      facets: facets,
      updateSearchFacets: updateSearchFacets,
      clearSearchFacets: clearSearchFacets,
      hasActiveFilters: hasActiveFilters,
      getSelectedCount: getSelectedCount,
      sortOptions: sortOptions,
      onSortChange: onSortChange,
      AzButtonText: AzButtonText,
      AzAccordion: AzAccordion,
      AzRadio: AzRadio,
      AzAccordionItem: AzAccordionItem,
      SearchFilterCheckboxOrganism: SearchFilterCheckboxOrganism,
      SearchFilterNestedOrganism: SearchFilterNestedOrganism,
      SearchFilterRangeOrganism: SearchFilterRangeOrganism,
      SearchFilterTagOrganism: SearchFilterTagOrganism,
      SearchFilterLinkOrganism: SearchFilterLinkOrganism
    };
  }
});